/**
 * @generated SignedSource<<844fbb52c6f5bfeeda728691e88795c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_item$data = {
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedContactDealerWrapper_item";
};
export type SharedContactDealerWrapper_item$key = {
  readonly " $data"?: SharedContactDealerWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "70e31ce2cc08365ed74962bdbf7ac3e9";

export default node;
